import { render, staticRenderFns } from "./CytomineChannel.vue?vue&type=template&id=23cfb05c&scoped=true"
import script from "./CytomineChannel.vue?vue&type=script&lang=js"
export * from "./CytomineChannel.vue?vue&type=script&lang=js"
import style0 from "./CytomineChannel.vue?vue&type=style&index=0&id=23cfb05c&prod&lang=css"
import style1 from "./CytomineChannel.vue?vue&type=style&index=1&id=23cfb05c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cfb05c",
  null
  
)

export default component.exports